export interface TTSProvider {
  unlock(): Promise<void>;
  speak(text: string): Promise<void>;
  cancel(): void;
  isAvailable(): boolean;
}

export class BrowserTTSProvider implements TTSProvider {
  private unlocked = false;
  isAvailable() { return "speechSynthesis" in window && "SpeechSynthesisUtterance" in window; }
  async unlock() {
    if (!this.isAvailable()) throw new Error("Speech synthesis is unavailable");
    speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(" ");
    utterance.volume = 0;
    speechSynthesis.speak(utterance);
    this.unlocked = true;
  }
  speak(text: string) {
    return new Promise<void>((resolve, reject) => {
      if (!this.unlocked) return reject(new Error("Audio requires a user gesture"));
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 1.05; utterance.pitch = 0.95;
      utterance.onend = () => resolve();
      utterance.onerror = (event) => reject(new Error(event.error));
      speechSynthesis.speak(utterance);
    });
  }
  cancel() { if (this.isAvailable()) speechSynthesis.cancel(); }
}

export async function acquireWakeLock(): Promise<{ release(): Promise<void> } | undefined> {
  const wakeLock = (navigator as Navigator & { wakeLock?: { request(type: "screen"): Promise<{ release(): Promise<void> }> } }).wakeLock;
  return wakeLock?.request("screen");
}

